
import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OfferService } from '../../shared/providers/offer.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service';
import { CounterOfferModel } from '../../shared/models/CounterOfferModel';
import { IFileUpload } from '../../shared/models/fileupload';
import { FileUploadService } from '../../shared/providers/fileupload.service';
import { PropertyDetailForOffer } from '../../shared/models/PropertyDetailForOffer';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { CommonService } from '../../shared/providers/common.service';


@Component({
    selector: 'app-counter-offer',
    templateUrl: './counter-offer.component.html'
})
export class CounterOfferComponent implements OnInit {

    counterOfferModel = {} as CounterOfferModel;
    offerGuid = '';
    user: any;
    isValid = true;
    errorMessage: string;
    fileExtensionType: string = "document";
    fileUploadType: string = "single";
    fileExtensionLOIType = "LOI";
    inputFileUpload = {} as IFileUpload;
    fileTypes = '.PDF, .DOCX, .DOC'
    selectedFilesForLOI: string[] = [];
    propertyGuid: string;
    propertyDetailForOffer = {} as PropertyDetailForOffer;
    disabledCounterBtn: boolean = false;
    counterPriceValid: boolean = false;
    earnestmoneyDepositValid: boolean = false;
    options = [{ name: "Buyer", id: 1 }, { name: "Seller", id: 2 }];
    optionSelected: any;
    isBroker: boolean = false;
    modalRef: BsModalRef;
    buyerOrSeller: string;

    constructor(private activatedRoute: ActivatedRoute, private authService: AuthenticationService, private offerService: OfferService, public Validation: ValidationService, private modalService: BsModalService,
        private _toastService: ToastService, private router: Router, private _fileUploadService: FileUploadService, private _offerService: OfferService, private Loader: LoaderService, public _commonService: CommonService) { }

    isAdmin = false;
    ngOnInit() {

        this.setUploadDefaultValues();
        this.user = this.authService.user;
      var role = this.user.Role;
      if (this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
            this.isBroker = true;
            this.optionSelected = 0;
      }
      if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
            this.isAdmin = true;
        }

        this.activatedRoute.params.subscribe(params => {
            this.offerGuid = params.id
            if (this.offerGuid != null) {
                this.Loader.display(true);
                this.offerService.getCounterOfferDetails(this.offerGuid).subscribe(response => {
                    this.counterOfferModel = response;
                    this.propertyGuid = this.counterOfferModel.PropertyGuid;
                    this.getPropertyDetail();

                    if (this.authService.Seller()) {
                        this._offerService.IsSellerOffer(this.user.Id, this.offerGuid).subscribe(res => {
                            this.isSellerUser = res as boolean;
                        });
                    }
                });
            }
        });
    }
    isSellerUser = false;
    openModalForCounterAccept(template: TemplateRef<any>, classes) {


        this.modalRef = this.modalService.show(template, { class: classes });
    }


    filesCollectionLOI = [];
    selectedFilesListEmitterForLOI(selectedFilesListEmitter: string[]) {
        this.errorMessage = null;
        this.selectedFilesForLOI = selectedFilesListEmitter;
        this.clearFiles++; //this.filesCollection = [];
        if (this.filesCollectionLOI.length < 1) {
            this.selectedFilesForLOI.forEach(item => {
                const fileObj =
                {
                    name: item["name"],
                    category: 0,
                    file: item
                }
                this.filesCollectionLOI.push(fileObj);
            });
        }
        else {
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Cannot upload multiple LOI documents', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
    }
    clearFiles: number = 0;
    uploadFiles() {
        this._fileUploadService.uploadFiles(this.inputFileUpload, this.selectedFilesForLOI).subscribe(response => {
            this.clearFiles++;
            this.Loader.display(false);
            this.redirectPage();

        });
    }

    onRemoveCounterDocument(i: any) {
        this.filesCollectionLOI.splice(i, 1);
        this.selectedFilesForLOI.splice(i, 1);
    }
    setUploadDefaultValues() {
        this.inputFileUpload.fileCategoryId = 412;
        this.inputFileUpload.id = 0;
        this.inputFileUpload.objectId = 0;
        this.inputFileUpload.objectTypeId = 303;
        this.inputFileUpload.documentName = "Broker Counter Document";
        this.inputFileUpload.type = "Documents";
    }

    saveCounter() {

        this.disabledCounterBtn = true;
        this.user = this.authService.user;

        if (this.validationForSaveCounter()) {

            this.counterOfferModel.LastModifiedUser = this.user.Id;
            if (this.isSellerUser) {
                this.optionSelected = 2;
            }
            this.counterOfferModel.IsFromBuyer = this.optionSelected == 2 ? false : true;
            this.buyerOrSeller = this.optionSelected == 2 ? "Seller" : "Buyer";
            if (this.authService.IsUserRole(this.authService.UserRole.Broker) && (this.optionSelected == 0 || this.optionSelected == '' || this.optionSelected == null)) {
                this._toastService.addToast({
                    title: 'Error Occurred', msg: 'Please select the Option', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
                });
                this.disabledCounterBtn = false;
            }
            else {
                this.Loader.display(true);
                this.offerService.saveCounterOffer(this.counterOfferModel).subscribe(response => {
                    if (response.Success) {
                        if (this.selectedFilesForLOI.length > 0) {
                            this.inputFileUpload.objectId = response.Id;
                            this.inputFileUpload.id = response.Id;
                            this.inputFileUpload.documentName = "CounterLOI_" + this.buyerOrSeller;
                            this.uploadFiles();
                        }
                        else {
                            this.Loader.display(false);
                            this.redirectPage();
                        }
                    }
                    else {
                        this.disabledCounterBtn = false;
                        this._toastService.addToast({ title: 'Error Occurred', msg: 'server side error is found', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                    }
                });
            }


        }
        else if (this.counterPriceValid == true) {
            this.disabledCounterBtn = false;
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Offer price should be greater than 0', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
        else if (this.earnestmoneyDepositValid == true) {
            this.disabledCounterBtn = false;
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Earnest Money Deposit should be greater than 0', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
        else {
            this.disabledCounterBtn = false;
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Please modify atlest one counter field', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
    }

    redirectPage() {
        this._toastService.addToast({
            title: 'Message', msg: 'Counter submitted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'

        });
        this.router.navigate(['/offer-detail/' + this.offerGuid]);
        this.disabledCounterBtn = false;
    }

    validationForSaveCounter() {
        this.isValid = true;
        if (this.isValid) {
            if ((this.counterOfferModel.CounterOfferPrice == null || this.counterOfferModel.CounterOfferPrice == "") && (this.counterOfferModel.CounterEarnestMoneyDeposit == null || this.counterOfferModel.CounterEarnestMoneyDeposit == "")
                && (this.counterOfferModel.CounterDueDiligencePeriod == null || this.counterOfferModel.CounterDueDiligencePeriod == "")
                && (this.counterOfferModel.CounterClosingPeriod == null || this.counterOfferModel.CounterClosingPeriod == "")) {
                this.isValid = false;
            }
            else if (this.counterOfferModel.OfferPrice == this.counterOfferModel.CounterOfferPrice && this.counterOfferModel.EarnestMoneyDeposit == this.counterOfferModel.CounterEarnestMoneyDeposit
                && this.counterOfferModel.DueDiligencePeriod == this.counterOfferModel.CounterDueDiligencePeriod && this.counterOfferModel.ClosingPeriod == this.counterOfferModel.CounterClosingPeriod) {
                this.isValid = false;
            }
        }
        return this.isValid;
    }

    counterPriceValidation() {
        if (this.counterOfferModel.CounterOfferPrice != null && this.counterOfferModel.CounterOfferPrice != "" && this.counterOfferModel.CounterOfferPrice == 0) {
            this.counterPriceValid = true;
            this.isValid = false;
        }
        else {
            this.counterPriceValid = false;
            this.isValid = true;
        }
    }

    earnestmoneyDepositValidation() {
        if (this.counterOfferModel.CounterEarnestMoneyDeposit != null && this.counterOfferModel.CounterEarnestMoneyDeposit != "" && this.counterOfferModel.CounterEarnestMoneyDeposit == 0) {
            this.earnestmoneyDepositValid = true;
            this.isValid = false;
        }
        else {
            this.earnestmoneyDepositValid = false;
            this.isValid = true;
        }
    }

    cancel() {
        this.router.navigate(['/offer-detail/' + this.offerGuid]);
    }

    getPropertyDetail() {
        this._offerService.getPropertyDetails(this.propertyGuid).subscribe(response => {
            this.propertyDetailForOffer = response;
            this.Loader.display(false);
            if (this.propertyDetailForOffer.FilePath === undefined || this.propertyDetailForOffer.FilePath === null || this.propertyDetailForOffer.FilePath === "") {
                this.propertyDetailForOffer.FilePath = '/../../../assets/img/default-property_1.png'
            }
            if (this.propertyDetailForOffer.PrimaryContactImagePath === undefined || this.propertyDetailForOffer.PrimaryContactImagePath === null || this.propertyDetailForOffer.PrimaryContactImagePath === "") {
                this.propertyDetailForOffer.PrimaryContactImagePath = '/../../../assets/img/default-profile-img.png'
            }
        })
    }
}
